define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'router', 'scroll'],
    function ($, transit, modernizr, container, preloader, router, scroll) {

        var module = (function () {

            var name = 'module-tv-our-story-chronicle';

            var model = container.getBaseModel(name);
            var view = container.getBaseView(name);
            var pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {};

            /* view */

            view.publicVars = {};

            view.privateVars = {};

            view.startup = function () {
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.tvOurStoryChronicleContentSubheaderCls, 'animate__slideInDown', 'tv-our-story-chronicle', {});
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.tvOurStoryPosterLabelCls, 'animate__zoomIn', 'tv-our-story-poster', {});

                // const length = $(view.publicVars.cssId.tvOurStoryChronicleTreeSvgPathCls)[0].getTotalLength();
                // console.log(length);
                //
                // $(view.publicVars.cssId.tvOurStoryChronicleTreeSvgPathCls).css({ strokeDashoffset: 7104 });

                view.methods.handleCurrentScrollPosition();
                view.methods.handleAnimClasses();
            };

            view.bind = function () {
                $(window).scroll(function () {

                    let ticking = false;

                    if (!ticking) {
                        window.requestAnimationFrame(function () {
                            view.methods.handleCurrentScrollPosition();
                            ticking = false;
                        });
                    }
                    ticking = true;

                });

                $(window).resize(() => {
                    view.methods.handleCurrentScrollPosition();
                    view.methods.handleAnimClasses();
                });

                $(window).on('orientationchange', () => {
                    view.methods.handleCurrentScrollPosition();
                    view.methods.handleAnimClasses();
                });
            };

            view.methods = {

                handleAnimClasses: () => {
                    const windowWidth = $(window).width();

                    if(windowWidth > 1260) {
                        $(view.publicVars.cssId.tvOurStoryChronicleItemCls + '1').removeClass('animate__animated animate_slow animate__fadeInLeft');
                        $(view.publicVars.cssId.tvOurStoryChronicleItemCls + '2').removeClass('animate__animated animate_slow animate__fadeInRight');
                        $(view.publicVars.cssId.tvOurStoryChronicleItemCls + '3').removeClass('animate__animated animate_slow animate__fadeInLeft');
                        $(view.publicVars.cssId.tvOurStoryChronicleItemCls + '4').removeClass('animate__animated animate_slow animate__fadeInRight');
                        $(view.publicVars.cssId.tvOurStoryChronicleItemCls + '5').removeClass('animate__animated animate_slow animate__fadeInLeft');
                        $(view.publicVars.cssId.tvOurStoryChronicleItemCls + '6').removeClass('animate__animated animate_slow animate__fadeInRight');
                        $(view.publicVars.cssId.tvOurStoryChronicleItemCls + '7').removeClass('animate__animated animate_slow animate__fadeInLeft');
                        $(view.publicVars.cssId.tvOurStoryChronicleItemCls + '8').removeClass('animate__animated animate_slow animate__fadeInRight');
                        $(view.publicVars.cssId.tvOurStoryChronicleItemCls + '8').removeClass('animate__animated animate_slow animate__fadeInLeft');

                        scroll.unregisterAnimatedElement(view.publicVars.cssId.tvOurStoryChronicleItemCls + '1');
                        scroll.unregisterAnimatedElement(view.publicVars.cssId.tvOurStoryChronicleItemCls + '2');
                        scroll.unregisterAnimatedElement(view.publicVars.cssId.tvOurStoryChronicleItemCls + '3');
                        scroll.unregisterAnimatedElement(view.publicVars.cssId.tvOurStoryChronicleItemCls + '4');
                        scroll.unregisterAnimatedElement(view.publicVars.cssId.tvOurStoryChronicleItemCls + '5');
                        scroll.unregisterAnimatedElement(view.publicVars.cssId.tvOurStoryChronicleItemCls + '6');
                        scroll.unregisterAnimatedElement(view.publicVars.cssId.tvOurStoryChronicleItemCls + '7');
                        scroll.unregisterAnimatedElement(view.publicVars.cssId.tvOurStoryChronicleItemCls + '8');
                        scroll.unregisterAnimatedElement(view.publicVars.cssId.tvOurStoryChronicleItemCls + '9');

                        $(view.publicVars.cssId.tvOurStoryChronicleItemCls).css({ visibility: 'visible'});
                    } else {
                        $(view.publicVars.cssId.tvOurStoryChronicleItemCls + '1').addClass('animate__animated animate_slow animate__fadeInLeft');
                        $(view.publicVars.cssId.tvOurStoryChronicleItemCls + '2').addClass('animate__animated animate_slow animate__fadeInRight');
                        $(view.publicVars.cssId.tvOurStoryChronicleItemCls + '3').addClass('animate__animated animate_slow animate__fadeInLeft');
                        $(view.publicVars.cssId.tvOurStoryChronicleItemCls + '4').addClass('animate__animated animate_slow animate__fadeInRight');
                        $(view.publicVars.cssId.tvOurStoryChronicleItemCls + '5').addClass('animate__animated animate_slow animate__fadeInLeft');
                        $(view.publicVars.cssId.tvOurStoryChronicleItemCls + '6').addClass('animate__animated animate_slow animate__fadeInRight');
                        $(view.publicVars.cssId.tvOurStoryChronicleItemCls + '7').addClass('animate__animated animate_slow animate__fadeInLeft');
                        $(view.publicVars.cssId.tvOurStoryChronicleItemCls + '8').addClass('animate__animated animate_slow animate__fadeInRight');
                        $(view.publicVars.cssId.tvOurStoryChronicleItemCls + '9').addClass('animate__animated animate_slow animate__fadeInLeft');

                        scroll.registerAnimatedElement(view.publicVars.cssId.tvOurStoryChronicleItemCls + '1', 'animate__fadeInLeft', 'tv-our-story-chronicle', {});
                        scroll.registerAnimatedElement(view.publicVars.cssId.tvOurStoryChronicleItemCls + '2', 'animate__fadeInRight', 'tv-our-story-chronicle', {});
                        scroll.registerAnimatedElement(view.publicVars.cssId.tvOurStoryChronicleItemCls + '3', 'animate__fadeInLeft', 'tv-our-story-chronicle', {});
                        scroll.registerAnimatedElement(view.publicVars.cssId.tvOurStoryChronicleItemCls + '4', 'animate__fadeInRight', 'tv-our-story-chronicle', {});
                        scroll.registerAnimatedElement(view.publicVars.cssId.tvOurStoryChronicleItemCls + '5', 'animate__fadeInLeft', 'tv-our-story-chronicle', {});
                        scroll.registerAnimatedElement(view.publicVars.cssId.tvOurStoryChronicleItemCls + '6', 'animate__fadeInRight', 'tv-our-story-chronicle', {});
                        scroll.registerAnimatedElement(view.publicVars.cssId.tvOurStoryChronicleItemCls + '7', 'animate__fadeInLeft', 'tv-our-story-chronicle', {});
                        scroll.registerAnimatedElement(view.publicVars.cssId.tvOurStoryChronicleItemCls + '8', 'animate__fadeInRight', 'tv-our-story-chronicle', {});
                        scroll.registerAnimatedElement(view.publicVars.cssId.tvOurStoryChronicleItemCls + '9', 'animate__fadeInLeft', 'tv-our-story-chronicle', {});
                    }
                },

                handleCurrentScrollPosition: () => {

                    const length = $(view.publicVars.cssId.tvOurStoryChronicleTreeSvgPathCls)[0].getTotalLength();

                    const systemCurrentScroll = $(document).scrollTop();
                    const scrollPlusWindowHeight = $(window).height() + systemCurrentScroll;
                    const targetPos = $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).offset();
                    const rect = $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls)[0].getBoundingClientRect();

                    const scrollRelative = scrollPlusWindowHeight - targetPos.top;

                    let strokeDashOffset = length - (scrollPlusWindowHeight - targetPos.top);

                    if(scrollRelative <= 275) {
                        strokeDashOffset = length - (scrollPlusWindowHeight * 0.9 - targetPos.top);
                    } else if(scrollRelative > 276 && scrollRelative <= 572) {
                        let scrollRelativeDiff = 296;
                        let currentRelative = 572 - scrollRelative;
                        let dashLength = 748;


                        let currentPercent = 1 - (currentRelative / scrollRelativeDiff);

                        strokeDashOffset = 8209 - parseInt(currentPercent * dashLength);
                    } else if(scrollRelative <= 812) {

                        /**
                         * 572 - top size of next photo
                         * 812 - bottom size of next photo
                         *
                         */


                        let scrollRelativeDiff = 240; //812 - 572
                        let currentRelative = 812 - scrollRelative;
                        let dashLength = 783; //length between photos

                        let currentPercent = 1 - (currentRelative / scrollRelativeDiff);

                        //6221 - where the svg dash offset starts and need to pass 783px
                        // to next photo if dashoffset = 0 then whole path is visible
                        strokeDashOffset = 7176 - parseInt(currentPercent * dashLength);
                    } else if(scrollRelative <= 1054) {
                        let scrollRelativeDiff = 242;
                        let currentRelative = 1054 - scrollRelative;

                        let dashLength = 776;

                        let currentPercent = 1 - (currentRelative / scrollRelativeDiff);

                        strokeDashOffset = 6122 - parseInt(currentPercent * dashLength);
                    } else if(scrollRelative <= 1294) {
                        let scrollRelativeDiff = 240;
                        let currentRelative = 1294 - scrollRelative;

                        let dashLength = 780;

                        let currentPercent = 1 - (currentRelative / scrollRelativeDiff);

                        strokeDashOffset = 5106 - parseInt(currentPercent * dashLength);
                    } else if(scrollRelative <= 1534) {
                        let scrollRelativeDiff = 240;
                        let currentRelative = 1534 - scrollRelative;

                        let dashLength = 772;

                        let currentPercent = 1 - (currentRelative / scrollRelativeDiff);

                        strokeDashOffset = 4050 - parseInt(currentPercent * dashLength);
                    } else if(scrollRelative <= 1776) {
                        let scrollRelativeDiff = 242;

                        let currentRelative = 1776 - scrollRelative;

                        let dashLength = 760;

                        let currentPercent = 1 - (currentRelative / scrollRelativeDiff);

                        strokeDashOffset = 3050 - parseInt(currentPercent * dashLength);
                    } else if(scrollRelative <= 2016) {
                        let scrollRelativeDiff = 242;

                        let currentRelative = 2016 - scrollRelative;

                        let dashLength = 760;

                        let currentPercent = 1 - (currentRelative / scrollRelativeDiff);

                        strokeDashOffset = 1950 - parseInt(currentPercent * dashLength);
                    } else {
                        let scrollRelativeDiff = 242;

                        let currentRelative = 2260 - scrollRelative;

                        let dashLength = 760;

                        let currentPercent = 1 - (currentRelative / scrollRelativeDiff);

                        strokeDashOffset = 920 - parseInt(currentPercent * dashLength);
                    }

                    // console.log('scroll relative: ' +scrollRelative);
                    // console.log('dash offset: ' +strokeDashOffset);
                    // console.log(scrollPlusWindowHeight - targetPos.top);

                    const windowWidth = $(window).width();

                    if(windowWidth < 1261) {
                        $(view.publicVars.cssId.tvOurStoryChronicleTreeSvgPathCls).removeAttr('style');

                        $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).removeClass(view.publicVars.cssId.hasItemActive.substr(1) + 1);
                        $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).removeClass(view.publicVars.cssId.hasItemActive.substr(1) + 2);
                        $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).removeClass(view.publicVars.cssId.hasItemActive.substr(1) + 3);
                        $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).removeClass(view.publicVars.cssId.hasItemActive.substr(1) + 4);
                        $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).removeClass(view.publicVars.cssId.hasItemActive.substr(1) + 5);
                        $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).removeClass(view.publicVars.cssId.hasItemActive.substr(1) + 6);
                        $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).removeClass(view.publicVars.cssId.hasItemActive.substr(1) + 7);
                        $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).removeClass(view.publicVars.cssId.hasItemActive.substr(1) + 8);
                        $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).removeClass(view.publicVars.cssId.hasItemActive.substr(1) + 9);

                    } else {
                        if (targetPos.top < scrollPlusWindowHeight &&
                            (scrollPlusWindowHeight < (targetPos.top + rect.height)
                                || systemCurrentScroll < (targetPos.top + rect.height))) {

                            if (scrollRelative > 276) {
                                $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).addClass(view.publicVars.cssId.hasItemActive.substr(1) + 1);
                            } else {
                                $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).removeClass(view.publicVars.cssId.hasItemActive.substr(1) + 1);
                            }

                            if (scrollRelative > 572) {
                                $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).addClass(view.publicVars.cssId.hasItemActive.substr(1) + 2);
                            } else {
                                $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).removeClass(view.publicVars.cssId.hasItemActive.substr(1) + 2);
                            }

                            if (scrollRelative > 812) {
                                $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).addClass(view.publicVars.cssId.hasItemActive.substr(1) + 3);
                            } else {
                                $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).removeClass(view.publicVars.cssId.hasItemActive.substr(1) + 3);
                            }

                            if (scrollRelative > 1054) {
                                $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).addClass(view.publicVars.cssId.hasItemActive.substr(1) + 4);
                            } else {
                                $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).removeClass(view.publicVars.cssId.hasItemActive.substr(1) + 4);
                            }

                            if (scrollRelative > 1294) {
                                $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).addClass(view.publicVars.cssId.hasItemActive.substr(1) + 5);
                            } else {
                                $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).removeClass(view.publicVars.cssId.hasItemActive.substr(1) + 5);
                            }

                            if (scrollRelative > 1534) {
                                $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).addClass(view.publicVars.cssId.hasItemActive.substr(1) + 6);
                            } else {
                                $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).removeClass(view.publicVars.cssId.hasItemActive.substr(1) + 6);
                            }

                            if (scrollRelative > 1776) {
                                $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).addClass(view.publicVars.cssId.hasItemActive.substr(1) + 7);
                            } else {
                                $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).removeClass(view.publicVars.cssId.hasItemActive.substr(1) + 7);
                            }

                            if (scrollRelative > 2018) {
                                $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).addClass(view.publicVars.cssId.hasItemActive.substr(1) + 8);
                            } else {
                                $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).removeClass(view.publicVars.cssId.hasItemActive.substr(1) + 8);
                            }

                            if (scrollRelative > 2260) {
                                $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).addClass(view.publicVars.cssId.hasItemActive.substr(1) + 9);
                            } else {
                                $(view.publicVars.cssId.tvOurStoryChronicleWrapperCls).removeClass(view.publicVars.cssId.hasItemActive.substr(1) + 9);
                            }

                            $(view.publicVars.cssId.tvOurStoryChronicleTreeSvgPathCls).css({strokeDashoffset: strokeDashOffset});
                        }
                    }


                },

                setCallbacks: (callbacks) => {
                    view.privateVars.callbacks = callbacks;
                }
            };

            /* custom events */

            // pubSub.subscribe('view/updateCharacterContent', view.methods.updateCharacterContent);

            //pubSub.subscribe('view/updateSuccessLikes', view.methods.updateSuccessLikes);
            //pubSub.subscribe('view/updateSuccessViews', view.methods.updateSuccessViews);

            /* public methods */
            return {
                init: function (options, callbacks) {
                    view.methods.setCallbacks(callbacks);
                    model.init(options);
                    view.init(options);
                    scroll.init();
                }
            };


        })();


        return module;

    });